/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

export const $vjc = 'addMissingAwait';
export const $wjc = 'addMissingNewOperator';
export const $xjc = 'fixOverrideModifier';
export const $yjc = 'annotateWithTypeFromJSDoc';
export const $zjc = 'fixAwaitInSyncFunction';
export const $Ajc = 'fixClassDoesntImplementInheritedAbstractMember';
export const $Bjc = 'fixClassIncorrectlyImplementsInterface';
export const $Cjc = 'constructorForDerivedNeedSuperCall';
export const $Djc = 'extendsInterfaceBecomesImplements';
export const $Ejc = 'import';
export const $Fjc = 'forgottenThisPropertyAccess';
export const $Gjc = 'removeUnnecessaryAwait';
export const $Hjc = 'spelling';
export const $Ijc = 'fixUnreachableCode';
export const $Jjc = 'unusedIdentifier';
